document.addEventListener("DOMContentLoaded", function () {
  const headerContainer = document.querySelector(".header__container");
  if (!headerContainer) return;

  const topRightMenuWrapper = document.createElement("div");
  topRightMenuWrapper.className = "menu-top-right-flyout";
  topRightMenuWrapper.innerHTML = `
    <div class="menu-top-right-button"><a href="/pages/denim-fit-guide-fw26">Denim Fit Guide</a></div>
    <div class="menu-top-right-button"><a href="/pages/outfits">Outfity</a></div>
    <div class="menu-top-right-button"><a href="/pages/vernostni-sleva">Replay Club</a></div>
    <!--<div class="menu-top-right-button"><a href="/pages/prodejny">Prodejny</a></div>-->
    <div class="menu-top-right-button"><a href="/pages/faq">FAQ</a></div>
    <div class="menu-top-right-button"><a href="/pages/kontakt">Kontakt</a></div>
    
  `;

  // Vložit vlevo do header containeru
  headerContainer.insertBefore(topRightMenuWrapper, headerContainer.firstChild);
});
